module.exports = __webpack_public_path__ + "static/media/kembackground.69ea901c.jpg";